import { breakpoints, theme } from '@notino/react-styleguide';

import {
  Wrapper as PriceLabelWrapper,
  CurrencyStyled as PriceLabelCurrencyWrapper,
} from '@components/PriceLabel/components/styled';
import { styled } from '@linaria/react';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Select = styled.div<{ isExpanded: boolean }>`
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  min-height: 3.5rem;
  padding: 0 1rem;
  user-select: none;
  border: 1px solid
    ${(props) =>
      props.isExpanded
        ? theme.color.border.selected
        : theme.color.border.divider};
  box-shadow: ${(props) =>
    props.isExpanded
      ? `inset 0 0 0 1px ${theme.color.border.selected}`
      : 'none'};
`;

export const SelectedVariantName = styled.span`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 1;
  flex-grow: 1;
  min-width: 0;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  order: 1;
  width: 100%;
`;

export const Text = styled.span`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: normal;
  margin-right: 0.625rem;

  ${theme.typography.labelRegular}
  color: ${theme.color.text.primary};
`;

export const ChevronIconWrapper = styled.button`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 0;
  cursor: pointer;
  color: ${theme.color.icon.secondary};
  width: 1.25rem;
  margin-left: 1rem;
  background-color: transparent;
`;

export const CloseWrapper = styled.div`
  width: 100%;
  text-align: right;
  padding: 0.5rem;
  height: 3.25rem;
  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`;

export const CloseIcon = styled.span`
  cursor: pointer;
  height: 2rem;
  display: inline-block;
  padding: 0.5rem;
`;

export const PriceAndName = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  align-items: center;
`;

export const Prices = styled.div`
  display: flex;
  align-items: baseline;
  flex-grow: 0;
  flex-shrink: 0;
  width: auto;
  flex-flow: column;
  justify-content: center;
  order: 2;
`;

export const PriceRatioWrapper = styled.div`
  margin-top: -0.5rem;
`;

export const PriceWrapper = styled(PriceLabelWrapper)`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
` as typeof PriceLabelWrapper;

export const CurrencyWrapper = styled(PriceLabelCurrencyWrapper)`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
` as typeof PriceLabelCurrencyWrapper;

export const DualPriceWrapper = styled.div`
  display: flex;
`;

export const DualPrice = styled.div`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
  font-size: 1.1rem;
  font-weight: 700;
  white-space: nowrap;
`;

export const DualPriceSplitter = styled.div`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
  padding: 0 0.2rem;
  font-size: 1.1rem;
  font-weight: 700;
`;
